import { defineMessages } from 'react-intl';

export const messages: {
	footer: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	footer: {
		defaultMessage: 'Powered by Jira Service Management',
		description: 'Message displayed in the company hub footer',
		id: 'company-hub.hub-app-shell.footer.powered.by.jira.service.management',
	},
});
